<template>
    <label class="ds-checkbox" :class="{ 'ds-checkbox--disabled': disabled }">
        <span class="ds-checkbox-box" :class="{ 'ds-checkbox-box--checked': checked }">
            <ds-icon v-if="checked" name="check" :size="14" />
        </span>
        <input
            type="checkbox"
            class="ds-checkbox-input"
            :checked="checked"
            :disabled="disabled"
            @change="$emit('change', $event)"
        />
        {{ label }}
    </label>
</template>

<script>
export default {
    name: 'DsCheckbox',
    props: {
        checked: { type: Boolean, default: false },
        label: { type: String, default: null },
        disabled: { type: Boolean, default: false },
    },
}
</script>

<style scoped>
.ds-checkbox {
    display: inline-flex;
    align-items: center;
    gap: var(--space-2);
    font: var(--type-body);
    color: var(--text-body);
    cursor: pointer;
}
.ds-checkbox--disabled { color: var(--text-disabled); cursor: default; }
.ds-checkbox-box {
    width: 18px;
    height: 18px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--radius-sm);
    border: var(--border-width) solid var(--border-field);
    background: var(--surface-card);
    color: var(--text-on-accent);
    transition: var(--transition-control);
    flex: 0 0 auto;
}
.ds-checkbox-box--checked {
    border-color: var(--action-primary);
    background: var(--action-primary);
}
.ds-checkbox-input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
}
</style>
